import { render, staticRenderFns } from "./teacherReports.vue?vue&type=template&id=6525de10&scoped=true"
import script from "./teacherReports.vue?vue&type=script&lang=js"
export * from "./teacherReports.vue?vue&type=script&lang=js"
import style0 from "./teacherReports.vue?vue&type=style&index=0&id=6525de10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6525de10",
  null
  
)

export default component.exports